import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { IBasket, IEcProduct } from '@/types/simo/basket';
import Button from '@/modules/Button';
import { getOrderStatus, getEasyUrl } from '@/api/simo';
import { getSessionStorage, setSessionStorage } from '@/utils/session';
import { detectSuccessfulPaymentURL } from '@/utils/helper';
import { paymentSuccess } from '@/api/urls';
import * as urls from '@/api/urls';

import './style.scss';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { view } from '@nuuday/data-layer';

interface IProps {
  setActiveSection: () => void;
  basket: IBasket;
  checkoutCms: any;
  ecProducts: IEcProduct[];
}

const Payment = (props: IProps) => {
  const [isLoading, setIsLoading] = useState(false);
  const { ecProducts } = props;
  const history = useHistory();

  const getPaymentUrl = async () => {
    setIsLoading(true);

    const acceptUrl = `${window.location.origin}${paymentSuccess.url()}`;

    const response = await getEasyUrl({
      acceptedUserRedirect: acceptUrl,
      rejectedUserRedirect: acceptUrl,
      termsAndConditionsLink: 'https://yousee.dk/hjaelp/kategori/vilkar-and-abonnement',
      termsOfCookiesLink: 'https://yousee.dk/hjaelp/kategori/vilkar-and-abonnement',
      _session: getSessionStorage('_session')
    });

    setIsLoading(false);

    return response.redirectUri;
  };

  const getStatus = async () => {
    setIsLoading(true);
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    const response = await getOrderStatus({
      basketIdFromNets: urlParams.get('basketId'),
      _session: getSessionStorage('_session')
    });

    if (response._session && getSessionStorage('_session') !== response._session) {
      setSessionStorage('_session', response._session);
    }

    if (response.orderStatus === 'ORDER_CONFIRMED') {
      history.push(urls.receipt.url({ state: { orderId: response.orderId } }));
    } else {
      window.location.assign(urls.fatalError.url({ step: 'pre_payment' }));
    }

    setIsLoading(false);
  };

  useEffect(() => {
    view({
      pageName: 'payment',
      siteSection: ['i hjemmet', 'mobil', 'simonly'],
      customEvent: ['ecCheckout'],
      pageType: 'simo checkout 7/8',
      ecProducts,
      mvGrossAdds: ecProducts?.length || 0
    });
    if (detectSuccessfulPaymentURL(window.location)) {
      getStatus();
    }
  }, []);

  const goToPayment = async () => {
    const redirectUrl = await getPaymentUrl();
    window.location.assign(redirectUrl);
  };

  return (
    <div className="payment">
      <p>{documentToReactComponents(props.checkoutCms.checkoutCms.paymentDescription.json)}</p>
      <Button loading={isLoading} value="Gå til betaling" onClick={goToPayment} />
    </div>
  );
};

export default Payment;
